import { type FC } from 'react'

import { CartIntermediateContinueShoppingButton } from './CartIntermediateContinueShoppingButton'
import { CartIntermediateGoToCartButton } from './CartIntermediateGoToCartButton'

type CartIntermediateCtaButtonsProps = {
  handleClose: () => void
}

export const CartIntermediateCtaButtons: FC<
  CartIntermediateCtaButtonsProps
> = ({ handleClose }) => {
  return (
    <div className="mb-5 mt-4 flex flex-col justify-between gap-4 tablet:flex-row">
      <CartIntermediateGoToCartButton onClick={handleClose} />
      <CartIntermediateContinueShoppingButton onClick={handleClose} />
    </div>
  )
}
